// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__QIctv"};